import {
    ConditionType, ConditionType_IsNull, ConditionType_NotNull,
    ConditionType_StringContains, ConditionType_StringEquals
} from "../../model2/conditions/condition-types"
import Filter from "../../manager/filters/manager/filter"

export const FIELD_CONDITIONS_STRING     = [
    ConditionType_StringContains,
    ConditionType_StringEquals,
    ConditionType_IsNull,
    ConditionType_NotNull,
]

// names can't be null
export const FIELD_CONDITIONS_NAME     = [
    ConditionType_StringContains,
    ConditionType_StringEquals,
]

// const debugString = "FieldString_filterFunc"
const debugString = false

export function FieldString_filterFunc(filter: Filter, model:any): boolean {

    if (!filter.type) return true
    if (filter.value?.length === 0) return true

    let fieldValue: string | null = _.get(model, filter.field?.fieldId!, null)

    const filterValue = filter.value || ''

    let res: boolean = true
    switch (filter.type) {
        case ConditionType.IS_NULL:
            res = _.isNil(fieldValue)
            break

        case ConditionType.NOT_NULL:
            res = !_.isNil(fieldValue)
            break

        case ConditionType.STRING_EQUALS:
            res = fieldValue?.trim() === filterValue?.trim()
            break

        case ConditionType.STRING_CONTAINS:
            res = gd.utils.search(fieldValue || "", filterValue)
            break
    }

    debugString && console.log(debugString, 'process', res, filter.type, fieldValue, filterValue)
    return res
}

export function FieldAddress_filterFunc(filter: Filter, model:any): boolean {

    let fieldValue: any = filter.field?.getDisplayValue(_.get(model, filter.field?.fieldId!,null))

    /*if (filter.isCustomField) {
        fieldValue = filter.field.getDisplayValue(_.get(model,'customFieldsData.'+filter.fieldId,null))
    } else {
        fieldValue = filter.field.getDisplayValue(_.get(model, filter.fieldId,null))
    }*/

    const filterValue = filter.value

    switch (filter.type) {
        case ConditionType.IS_NULL:
            return _.isNil(fieldValue)
        case ConditionType.NOT_NULL:
            return !_.isNil(fieldValue)
        case ConditionType.STRING_EQUALS:
            return (fieldValue?.place.address || "") === filterValue?.trim()
        case ConditionType.STRING_CONTAINS:
            return gd.utils.search(fieldValue || "", filterValue)
        default:
            return false
    }

}